// Which clicks on an invoice-modal section's header row open or close it
// (owner, 2026-10-08 — `docs/decisions.md` D-329 amended). Pure, so the test
// suite can pin it without a DOM; `components/CollapsibleSection.tsx` calls it.

/** What counts as a control of its own on the header row: a click on one of
    these does its own job and leaves the section as it is. */
const OWN_CONTROL =
  'button, a[href], input, select, textarea, label, [role="button"], [role="link"], [role="checkbox"], [role="switch"], [role="menuitem"], [role="tab"], [contenteditable="true"]'

/**
 * Should a click on the header row open or close the section? Yes, unless it
 * landed on a control of its own (Flags' "Mark All N Resolved", say) — the
 * heading's own button excepted, which is the toggle.
 */
export function headerClickToggles(
  target: { closest(selector: string): unknown } | null,
  toggle: unknown,
): boolean {
  if (!target) return false
  const control = target.closest(OWN_CONTROL)
  return control === null || control === toggle
}
